module.exports = __webpack_public_path__ + "static/lights38-5a8fa47636ad0b51bae0201cc32191b8.jpg";